/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { Children, type ForwardedRef, type HTMLAttributes, type ReactNode, createContext, isValidElement } from 'react';
import { type ContextValue, Provider, createLeafComponent, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { Divider, DividerContext } from '../divider/divider.component';
import { Text, TextContext } from '../text/text.component';

interface MessageDividerProps extends Omit<HTMLAttributes<HTMLLIElement>, 'style' | 'className'> {
  isCritical?: boolean;
  style?: stylex.StyleXStyles;
  children?: ReactNode;
}

const MessageDividerContext = createContext<ContextValue<MessageDividerProps, HTMLLIElement>>({});

const MessageDivider = createLeafComponent('item', (props: MessageDividerProps, ref: ForwardedRef<HTMLLIElement>) => {
  [props, ref] = useContextProps(props, ref, MessageDividerContext);

  const { children, isCritical = false, style, ...coreProps } = props;

  const isTextOnly = Children.toArray(children).every(c => !isValidElement(c));

  return (
    <li ref={ref} role="separator" {...stylex.props(styles.base, style)} {...coreProps}>
      <Provider values={[
        [DividerContext, {
          size: 0.5,
          style: [styles.divider, isCritical ? dividerVariantVariants.critical : dividerVariantVariants.ghost]
        }],
        [TextContext, {
          size: 13,
          color: isCritical ? 'critical' : 'placeholder',
        }]
      ]}>
        <Divider />
        {isTextOnly ? <Text>{children}</Text> : children}
        <Divider />
      </Provider>
    </li>
  );
});

const styles = stylex.create({
  base: {
    gap: 24,
    alignItems: 'center',
    display: 'flex',
    // paddingRight: 16,
    width: '100%',
  },
  divider: {
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    minWidth: 0,
    width: 'auto',
  },
});

const dividerVariantVariants = stylex.create({
  critical: {
    backgroundColor: $.textCritical,
  },
  ghost: {
    backgroundColor: 'transparent',
  }
});

export { MessageDivider, MessageDividerContext, type MessageDividerProps };
